const priceOptions = document.querySelectorAll('.product-prices .price-option');
const priceButtons = document.querySelectorAll('.product-prices .price-option .price-toggle');
const priceTabButtons = document.querySelectorAll('button.price-toggle');

function removeActivePrice() {
    priceTabButtons.forEach(option => option.classList.remove('active'));
    priceTabButtons.forEach(button => {
        button.setAttribute('aria-selected', 'false');
        button.setAttribute('tabindex', '-1');
    });
    priceOptions.forEach(option => {
        option.classList.remove('active');
        option.classList.add('hidden');
    });
}

export function initPriceTabs() {
    if (priceTabButtons) {
        priceTabButtons.forEach(button => {
            button.addEventListener('click', function(this: HTMLButtonElement) {
                removeActivePrice();
                this.setAttribute('aria-selected', 'true');
                this.setAttribute('tabindex', '0');
                this.classList.add('active');
                const containerId = this.getAttribute('aria-controls');

                if (containerId) {
                    const container = document.getElementById(containerId);
                    if (container) {
                        container.classList.remove('hidden');
                        container.classList.add('active');
                    }
                }
            });

            button.addEventListener('keydown', function(event: KeyboardEvent) {
                if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
                    event.preventDefault();
                    const currentIndex = Array.from(priceTabButtons).indexOf(this);
                    let nextIndex = currentIndex;

                    if (event.key === 'ArrowLeft') {
                        nextIndex = (currentIndex - 1 + priceTabButtons.length) % priceTabButtons.length;
                    } else if (event.key === 'ArrowRight') {
                        nextIndex = (currentIndex + 1) % priceTabButtons.length;
                    }

                    const nextButton = priceTabButtons[nextIndex] as HTMLButtonElement;
                    nextButton.focus();
                    nextButton.click();
                }
            });
        });
    }
}
